import type { QualityRisk } from '~/gql/quality/quality'
import { QualityRiskStatus } from '@zeus/index'

/** Le formulaire d'un risque qualité (#328). */
export type RiskForm = {
  title: string
  description: string
  likelihood: number
  impact: number
  mitigation: string
  owner: string
  status: QualityRiskStatus
}

export function riskForm(risk: QualityRisk | undefined): RiskForm {
  return {
    title: risk?.title ?? '',
    description: risk?.description ?? '',
    likelihood: risk?.likelihood ?? 2,
    impact: risk?.impact ?? 2,
    mitigation: risk?.mitigation ?? '',
    owner: risk?.owner ?? '',
    status: risk?.status ?? QualityRiskStatus.OPEN,
  }
}

export function isRiskFormValid(form: RiskForm): boolean {
  return !!form.title.trim() && !!form.description.trim()
}
